export const CANCEL = "CANCEL";
export const UPDATE = "UPDATE";
export const CUSTOM_PLACEHOLDER_TEXT = "Custom Message Type Here";
export const CUSTOM_ERR_MSG = "Custom message is mandatory";
export const PRENOTES_ERR_MSG = "Pre-defined note is mandatory";
export const CUSTOM_PRENOTES_ERR_MSG =
  "Please select a pre-defined note or enter a custom message in order to proceed";
export const SUBMIT_ERROR = "There was an error while saving the vendor status!";
export const COMPLETE = "Complete";
export const APPROVED = "Approved";
export const IN_PROCESS = "In Process";
export const PENDING = "Pending";
export const NOT_STARTED = "Not Started";
export const ORDER_TESTING = "orderTesting";
export const LIVE_STATUS_NAME = "live";
export const LIVE_STATUS_ID = 11;
export const LIVE_ERR_MSG =
  "Cannot move this vendor out of “Live” status at this time. Please contact mtech for support.";